module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_victoria_contra_celulitis.b0e60b22.jpg";